// v3.4 Multi-Act structure — floors mapped to explicit acts with biome + banner text.
// Acts are inferred from floor number (backward-compatible with existing linear map).

export const ACTS = [
  {
    id: 1, name: 'ACT I — CHRONICALLY ONLINE',
    floorStart: 1, floorEnd: 10,
    tint: '#39ff14', bg: '#04120a',
    tagline: 'the algorithm is watching. it wants a fight.',
    banner: '📱',
  },
  {
    id: 2, name: 'ACT II — THE DISCOURSE',
    floorStart: 11, floorEnd: 15,
    tint: '#ff007f', bg: '#1a0810',
    tagline: 'the ratio never ends. the discourse always does.',
    banner: '💬',
  },
  {
    id: 3, name: 'ACT III — THE RATIO',
    floorStart: 16, floorEnd: 999,
    tint: '#ffd700', bg: '#1a1200',
    tagline: 'you are the discourse now. slop or be slopped.',
    banner: '👑',
  },
];

export function actForFloor(floor) {
  const f = Math.max(1, Math.floor(floor || 1));
  for (const act of ACTS) {
    if (f >= act.floorStart && f <= act.floorEnd) return act;
  }
  return ACTS[ACTS.length - 1];
}

// Returns true if this floor is the FIRST floor of a new act (used to trigger a transition banner)
export function isActStart(floor) {
  const act = actForFloor(floor);
  return act.floorStart === floor;
}
